import { jsx as _jsx } from "react/jsx-runtime";
import { DateTimePicker } from '@airtel/air-design-system';
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { getTableDateRangeStyles } from './TableDatePickerStyles';
var TableDatePicker = props => {
  var dateWidgetProps = props.dateWidgetProps,
    dateFilterCallBackHandler = props.dateFilterCallBackHandler,
    onClearButtonClick = props.onClearButtonClick,
    onUserAction = props.onUserAction;
  var datePickerStyles = getTableDateRangeStyles();
  var _useState = useState(null),
    dateFilterPropsState = _useState[0],
    setDateFilterProps = _useState[1];
  useEffect(() => {
    var dateFilter = dateWidgetProps.map(item => {
      if (item.mode === "date-range") {
        return Object.assign(Object.assign({}, item), {
          startDate: (item === null || item === void 0 ? void 0 : item.startDate) ? new Date(item.startDate) : null,
          endDate: (item === null || item === void 0 ? void 0 : item.endDate) ? new Date(item.endDate) : null,
          maxDate: (item === null || item === void 0 ? void 0 : item.maxDate) ? new Date(item.maxDate) : null,
          minDate: (item === null || item === void 0 ? void 0 : item.minDate) ? new Date(item.minDate) : null
        });
      }
      if (item.mode === "date") {
        return Object.assign(Object.assign({}, item), {
          startDate: (item === null || item === void 0 ? void 0 : item.startDate) ? new Date(item.startDate) : null,
          maxDate: (item === null || item === void 0 ? void 0 : item.maxDate) ? new Date(item.maxDate) : null,
          minDate: (item === null || item === void 0 ? void 0 : item.minDate) ? new Date(item.minDate) : null
        });
      }
    });
    setDateFilterProps(dateFilter);
  }, [dateWidgetProps]);
  var onClearButtonClicked = onClearButtonPressMetaData => {
    onClearButtonPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onClearButtonPressMetaData)));
    onClearButtonClick();
  };
  return _jsx(View, Object.assign({
    style: datePickerStyles.filterContainer
  }, {
    children: (dateFilterPropsState === null || dateFilterPropsState === void 0 ? void 0 : dateFilterPropsState.length) > 0 && dateFilterPropsState.map((item, index) => {
      var filterByColumnId = item.filterByColumnId,
        _item$mode = item.mode,
        mode = _item$mode === void 0 ? 'date' : _item$mode,
        onDateRangeChangeMetaData = item.onDateRangeChangeMetaData,
        _item$filterOnTableCe = item.filterOnTableCellProp,
        filterOnTableCellProp = _item$filterOnTableCe === void 0 ? 'heading' : _item$filterOnTableCe,
        _item$isServerSideFil = item.isServerSideFilteringEnabled,
        isServerSideFilteringEnabled = _item$isServerSideFil === void 0 ? false : _item$isServerSideFil,
        inputProps = item.inputProps;
      var onClearButtonPressMetaData = inputProps.onClearButtonPressMetaData;
      item.inputProps.onClearButtonPress = () => onClearButtonClicked(onClearButtonPressMetaData);
      return _jsx(View, Object.assign({
        style: datePickerStyles.dateFilterWrapper
      }, {
        children: _jsx(DateTimePicker, Object.assign({}, item, {
          onChange: event => dateFilterCallBackHandler(event, filterOnTableCellProp, isServerSideFilteringEnabled, filterByColumnId, mode, onDateRangeChangeMetaData)
        }))
      }), index + "key");
    })
  }));
};
export default TableDatePicker;